const LoginPage = () => import('@/views/login/LoginPage')

export const loginRootPages = [
  {
    path: '/connect',
    name: 'login',
    component: LoginPage
  }
]
